<template>
    <vs-icon
        v-if="useMdi"
        :icon="icon"
        :color="color_x"
        :bg="backgroundColor_x"
        :size="size_x"
        :round="rounded"
        :class="{ 'avatar-icon-container': rounded }"
    />
    <feather-icon
        v-else
        :style="styles"
        :class="{ 'avatar-icon-container': rounded }"
        v-on="$listeners"
        v-bind="attrs"
    />
</template>

<script>
import _color from '@/assets/utils/color.js'

export default {
    name: 'vx-basic-icon',
    props: {
        useMdi: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            required: true
        },
        size: {
            type: [Number, String],
            default: 6
        },
        color: {
            type: String,
            default: 'dark'
        },
        rounded: {
            type: Boolean,
            default: false
        },
        filled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    computed: {
        attrs() {
            return {
                ...this.$attrs,
                icon: this.parsedIcon,
                svgClasses: `h-full w-full`,
                style: this.styles,
                filled: this.filled
            }
        },
        size_x() {
            return `${this.size * 0.25}rem`
        },
        sizeStyle() {
            return `height:${this.size_x}; width:${this.size_x};`
        },
        styles() {
            return [this.colorStyle, this.backgroundColor, this.sizeStyle, this.$attrs.style]
                .where((i) => !!i)
                .join(' ')
        },
        color_x() {
            return _color.getColorString(this.color, 1)
        },
        colorStyle() {
            return `color: ${this.color_x};`
        },
        backgroundColor_x() {
            if (!this.rounded) {
                return ''
            }
            return _color.getColorString(this.color, 0.2)
        },
        backgroundColor() {
            if (!this.rounded) {
                return ''
            }
            return `background-color: ${this.backgroundColor_x};`
        },
        parsedIcon() {
            var pascalIcon = this.icon.toPascalCase()
            if (pascalIcon.startsWith('Icon')) {
                var parsedIconName = pascalIcon.substring(4, pascalIcon.length)
                return `${parsedIconName}Icon`
            }
            return pascalIcon
        }
    },
    methods: {}
}
</script>

<style scoped>
.feather-icon ::v-deep svg {
    padding: 0;
    transition-delay: 0s;
    transition-duration: 0.25s;
    transition-property: all;
    transition-timing-function: ease-out;
    stroke-width: 2px !important;
    user-select: none;
}
.avatar-icon-container {
    width: 100%;
    aspect-ratio: 1;
    border-radius: 50%;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    flex-shrink: 0;
}
</style>
